import type { DashboardTabDefinition } from './types';

export const DEFAULT_VIZ_TABS: DashboardTabDefinition[] = [
  { id: 'tab_bar', label: 'Bar', viz: 'bar' },
  { id: 'tab_line', label: 'Line', viz: 'line' },
  { id: 'tab_cal', label: 'Calendar', viz: 'calendar' },
  { id: 'tab_donut', label: 'Donut', viz: 'donut' },
];
